import { render, staticRenderFns } from "./ProfileDataList.vue?vue&type=template&id=02ed5df0&scoped=true&"
import script from "./ProfileDataList.vue?vue&type=script&lang=ts&"
export * from "./ProfileDataList.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileDataList.vue?vue&type=style&index=0&id=02ed5df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed5df0",
  null
  
)

export default component.exports